import React from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import HomePage from '../home/HomePage';
function RouterApp() {

    var filename = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
//	if(filename===""){
//     		window.location="/home";
//    	}
        return (
            <>
                <Router>
                    <>
                        <Switch>
                            <Route path="/" exact component={HomePage} />
                            <Route path="/home" exact component={HomePage} />
                        </Switch>
                    </>
                </Router>
            </>
        )
}


export default RouterApp
